<template>
  <div class="help-main">
    <img class="help-img" src="@/assets/Help.png" alt="" @click="helpClicked">
    <!-- <img class="help-img" :src="require(`${helpItems[0].img}`)" alt="" @click="helpClicked()"> -->
    <div class="help-mini-content" v-if="showMiniContent" tabindex="3" @blur="miniHelpFocusOut()" ref="miniContent"> 
      <div v-if="leftArrow" class="mini-arrow-left"></div>
      <div v-if="rightArrow" class="mini-arrow-right"></div>
      {{ popoverHelp }}
    </div>

    <div v-if="showContent" class="help-content">
      <div id="helpCarousel" class="carousel slide my-carousel" data-interval="false" data-ride="carousel" data-wrap="false" ref="myCarousel">
        <div class="content-header">{{ title }} : How to</div>
        <ol class="carousel-indicators">
          <li v-for="(h, index) in helpItems" :key="h" data-target="#helpCarousel" :data-slide-to="index" :class="{ 'active': index == 0 }"></li>
          <div class="pages">
            <a class="prev-next-control previous" ref="previous" href="#helpCarousel" role="button" data-slide="prev"></a>
            Page {{ currentPage }} of {{ helpItems.length }} 
            <a class="prev-next-control next" ref="next" href="#helpCarousel" role="button" data-slide="next"></a>
          </div>
        </ol>
        <div class="carousel-inner my-carousel-inner">
          <div v-for="(h, index) in helpItems" :key="h" :class="{ 'carousel-item my-carousel-item active': index == 0, 'carousel-item my-carousel-item': index != 0 }">
            <div class="my-item">
              <img :src="require(`@/assets/${h.img}`)" alt="">
              <div class="caption">{{ h.caption }}</div>
            </div>
          </div>
        </div>
        <div class="close-btn" @click="closeClicked()">X</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  props: {
    showContent: { type: Boolean, default: false },
    showMiniContent: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    leftArrow: { type: Boolean, default: true },
    rightArrow: { type: Boolean, default: false },
    
    title: { type: String, default: 'Header' },
    helpItems: { type: Array, default: [] },
    popover: { type: Boolean, default: false },
    popoverHelp: { type: String, default: 'Not set' }
  },
  methods: {
    helpClicked: function(e) {
      this.$emit('helpOpened', true);
      if (this.popover == true) {
        this.showMiniContent = true;
      } else {
        this.showContent = true;
      }

      setTimeout(() => {
        if (this.popover == true) {
          var showRight = (e.clientX + 200) >= window.innerWidth;
          this.$refs.miniContent.focus();
          if (showRight) {
            this.leftArrow = false;
            this.rightArrow = true;
            this.$refs.miniContent.style.right = window.innerWidth - e.clientX + 10 + 'px';
            this.$refs.miniContent.style.top = (e.clientY - 20) + 'px';
          } else {
            this.$refs.miniContent.style.left = (e.clientX + 10) + 'px';
            this.$refs.miniContent.style.top = (e.clientY - 20) + 'px';
            this.leftArrow = true;
            this.rightArrow = false;
          }
        } else {
          $(this.$refs.myCarousel).on('slid.bs.carousel', this.onPageChanged)

          // for (var i = 0; i < 20; i++) {
          //   this.helpItems.push(this.helpItems[0]);
          // } 

          var moveLeftRight = (this.helpItems.length * 10);

          this.$refs.previous.style.left = (moveLeftRight * -1) + 'px';
          this.$refs.next.style.right = (moveLeftRight * -1) + 'px';
        }
      }, 1);
    },
    closeClicked: function() {
      this.$emit('helpOpened', false);
      this.showContent = false;
      this.currentPage = 1;
    },
    onPageChanged: function(next) {
      this.currentPage = next.to + 1;
    },
    miniHelpFocusOut: function() {
      this.showMiniContent = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
$arrow-size: 10px;

.help-main {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  height: fit-content;
  // background-color: red;
  z-index: 9999;
}

.help-img {
  height: 20px;
  width: 20px;
}

.help-img:hover, .close-btn {
  cursor: pointer;
}

.help-content {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: $top-nav-height;
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  background-color: rgba(0,0,0,0.2);
}

.help-mini-content {
  position: fixed;
  padding: 10px;
  background-color: white;
  border: 1px solid black;
  max-width: 300px;
}

.help-mini-content .mini-arrow-left {
  border-width: $arrow-size $arrow-size $arrow-size $arrow-size;
  border-style: solid;
  border-color: transparent black transparent transparent;
  position: absolute;
  left: -20px;
  top: 10px;
}

.help-mini-content .mini-arrow-left:before {
  content: "";
  border-width: calc(#{$arrow-size}) calc(#{$arrow-size}) calc(#{$arrow-size}) calc(#{$arrow-size});
  border-style: solid;
  border-color: transparent white transparent transparent;
  position: absolute;
  left: calc((#{$arrow-size} - 1px) * -1);
  top: calc((#{$arrow-size}) * -1);
}

.help-mini-content .mini-arrow-right {
  border-width: $arrow-size $arrow-size $arrow-size $arrow-size;
  border-style: solid;
  border-color: transparent transparent transparent black;
  position: absolute;
  right: -20px;
  top: 10px;
}

.help-mini-content .mini-arrow-right:before {
  content: "";
  border-width: calc(#{$arrow-size}) calc(#{$arrow-size}) calc(#{$arrow-size}) calc(#{$arrow-size});
  border-style: solid;
  border-color: transparent transparent transparent white;
  position: absolute;
  left: calc((#{$arrow-size} + 1px) * -1);
  top: calc((#{$arrow-size}) * -1);
}

.help-mini-content:focus {
  outline: none;
}

.content-header {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  // background-color: red;
  width: 100%;
  height: 10%;
  margin: 10px 0;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: bold;
  font-size: 1.5em;
}

.my-carousel {
  display: flex;
  align-items: center;
  background-color: white;
  // background-color: gray;
  // border: 2px solid black;
  border-radius: 10px;
  width: 80%;
  height: 80%;
  box-shadow: 5px 5px 10px 0px black;
}

.my-carousel .close-btn {
  position: absolute;
  top: 0;
  right: 0;
  background-color: red;
  color: white;
  margin: 5px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  z-index: 5;
}

.carousel-inner .carousel-item {
  transition-duration: 0.3s;
}

.my-carousel-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
}

.my-carousel-item {
  left: 0;
  position: absolute;
  height: 100%;
}

.carousel-control-next:hover, .carousel-control-prev:hover {
  background-color: rgba(192,192,192,0.5);
}

.my-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.my-item .caption {
  position: absolute;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  bottom: 0;
  width: 100%;
  height: 20%;
  text-align: center;
  white-space: pre-wrap;
}

.my-item img {
  max-height: 80%;
  // height: 80%;
  // background-color: yellow;
}

.pages {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: absolute;
  top: 50%;
}

.prev-next-control {
  position: absolute;
  // background-color: blue;
  top: -20%;
  height: 15px;
  width: 15px;
  background-color: rgba(0,0,0,0.2);
  transition: $transition-time;
}

.prev-next-control:hover {
  background-color: black;
}

.pages .next {
  transform: rotate(45deg);
}

.next::after {
  content: "";
  display: block;
  position: absolute;
  height: 15px;
  width: 15px;
  right: 5px;
  top: 5px;
  background-color: white;
}

.pages .previous {
  transform: rotate(-45deg);
}

.previous::after {
  content: "";
  display: block;
  position: absolute;
  height: 15px;
  width: 15px;
  left: 5px;
  top: 5px;
  background-color: white;
}

.carousel-indicators {
  display: flex;
  align-items: baseline;
  // background-color: red;
}

.carousel-indicators li {
  position: relative;
  top: 10;
  background-color: transparent;
  border: 1px solid black;
  opacity: 1;
  height: 8px;
  width: 8px;
  border-radius: 100%;
  margin-bottom: 15px;
  transition: 0.6s;
}

.carousel-indicators .active {
  background-color: black;
}
</style>